import { Box, ListItem, ListItemText, alpha } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import Link from "next/link";

type Props = {
	title: string;
	link: `/${string}`;
};

export function SubItem({ title, link }: Props) {
	return (
		<ListItem
			disablePadding
			disableGutters
			component={Link}
			href={link}
			sx={{
				borderRadius: 1,
				opacity: 0.8,
				"&:hover": {
					backgroundColor: alpha(blueGrey[800], 0.1),
				},
			}}
		>
			<Box sx={{ minWidth: 42 }} />
			<ListItemText
				sx={{ color: blueGrey[600], marginBlock: 0.25 }}
				slotProps={{
					primary: {
						fontSize: "0.95rem",
					},
				}}
				primary={title}
			/>
		</ListItem>
	);
}
